import {ResizeHelper} from "./helpers/resize-helper";
import {Menu} from "./menu";
import { CalendarWidget } from "./main";
import { Utils } from "./utils";

export class FilterBarDock {
	private static mainElement: Element;
	private static filterBarElement: HTMLElement;
	private static dockYPos: number;

	public static devider:HTMLCollectionOf<Element>;
	public static filterBarBottomPosition:number = 100;

	private static filterBarDate:HTMLElement;
	private static filterChangedCallback: (firstParam:any,secondParam:any)=> void;

	private static resizeHelper: ResizeHelper;
	private static mainMenu:HTMLElement;
	private static filterBar:HTMLElement
	private static footer:HTMLElement;
	private static filterBarInner:HTMLElement;
	private static filterBarBottomHeight:number;
	private static isDockedBottom = false;

	public static init() {
		document.addEventListener('DOMContentLoaded', FilterBarDock.onDocumentLoaded, false);
		var header = document.getElementsByTagName("main")[0];
		if(header != null){
			FilterBarDock.mainElement = header;
		}		
		FilterBarDock.footer = <HTMLElement>document.getElementById("footer");
		FilterBarDock.resizeHelper = new ResizeHelper(FilterBarDock.resizeFinished);
	}


	private static resizeFinished(){
		if(FilterBarDock.filterBarInner == null){
			return;
		}

		const menuBottom = FilterBarDock.mainMenu.offsetTop + FilterBarDock.mainMenu.clientHeight
		FilterBarDock.dockYPos = FilterBarDock.filterBar.offsetTop - menuBottom;
		FilterBarDock.onScroll();
		FilterBarDock.reInit();
		FilterBarDock.filterBarBottomHeight = FilterBarDock.filterBarInner.offsetHeight + FilterBarDock.filterBarInner.offsetTop;
		let filterBarPlaceHolder = document.getElementById("filterBarPlaceHolder");
		if(filterBarPlaceHolder != null){
			if(!Menu.isMoblieMenu()){
				if(FilterBarDock.filterBar.offsetHeight > 1){
					filterBarPlaceHolder.style.height = FilterBarDock.filterBar.offsetHeight + "px";
				}
			}else{
				filterBarPlaceHolder.style.height = "auto";
			}
		}
		if(FilterBarDock.filterBarElement != null){
			var fixedElement = FilterBarDock.filterBarElement.firstElementChild;
			if(fixedElement != null){
				var style = window.getComputedStyle(fixedElement);
				if(style.position === "fixed"){
					FilterBarDock.mainElement.classList.toggle("filterBarDocked",true);
				}else{
					FilterBarDock.mainElement.classList.toggle("filterBarDocked",false);
				}
			}
		}
	}

	public static initOnLoaded(filterBarDate:HTMLElement,filterChangedCallback: (firstParam:any,secondParam:any)=> void) {
		FilterBarDock.filterBarDate = filterBarDate;
		FilterBarDock.filterChangedCallback = filterChangedCallback;

		var filterListItem = document.getElementsByClassName("_filterListItem");
		for(var i = 0; i < filterListItem.length; i++){
			filterListItem.item(i).addEventListener('click',FilterBarDock.filterChanged);
		}
		var filterWrapper = document.getElementsByClassName("_filterCateogories").item(0);
		var cancelfilterListItem = filterWrapper.getElementsByClassName("icon-close");
		for(var i = 0; i < cancelfilterListItem.length; i++){
			cancelfilterListItem.item(i).addEventListener('click',FilterBarDock.filterChanged);
		}
	}


	private static reInit(){
		FilterBarDock.filterBar = <HTMLElement>document.getElementById("filterBar");
		FilterBarDock.mainMenu = <HTMLElement>document.getElementById("nav_mainMenuWrapper");

		if(FilterBarDock.filterBar != null && FilterBarDock.mainMenu != null){
			FilterBarDock.filterBarBottomPosition = FilterBarDock.mainMenu.offsetTop + FilterBarDock.mainMenu.clientHeight + (FilterBarDock.filterBar.children.item(0) as HTMLElement).clientHeight;
		}

		if(FilterBarDock.filterBar == null || FilterBarDock.mainMenu == null) {
			return;
		}

		var filterBarToggleText = FilterBarDock.filterBar.getElementsByClassName("_filterCategory");
		if(filterBarToggleText.length > 0 && filterBarToggleText != null && !Menu.isMoblieMenu()){
			for(var i =0; i< filterBarToggleText.length; i++){
				filterBarToggleText.item(i).addEventListener("click", FilterBarDock.onFilterBarClick);
			}
		} else{
			var filterBarToggleIcon = FilterBarDock.filterBar.getElementsByClassName("icon-arrow-2-down");

			if(filterBarToggleIcon.length > 0 && filterBarToggleIcon != null){
				for(var i =0; i< filterBarToggleIcon.length; i++){
					filterBarToggleIcon.item(i).addEventListener("click", FilterBarDock.onFilterBarClick);
				}
			}
		}

		var filterBarCloseIcon = FilterBarDock.filterBar.getElementsByClassName("_filterClose")[0];

		if(filterBarCloseIcon != null){
			filterBarCloseIcon.addEventListener("click", FilterBarDock.onFilterBarClick);
		}

		var filterBarItems = FilterBarDock.filterBar.getElementsByClassName("_filterListItem");
		if(filterBarItems.length > 0 && filterBarItems != null){
			for(var i =0; i< filterBarItems.length; i++){
				filterBarItems.item(i).addEventListener("click", FilterBarDock.onFilterBarClick);
			}
		}

		var filterBarCategories = FilterBarDock.filterBar.getElementsByClassName("_category");
		if(filterBarCategories.length > 0 && filterBarItems != null){
			if(Menu.isMoblieMenu()){
				for(var i =0; i< filterBarCategories.length; i++){
					filterBarCategories.item(i).addEventListener("click", FilterBarDock.onFilterBarClick);
				}
			}else{
				for(var i =0; i< filterBarCategories.length; i++){
					filterBarCategories.item(i).removeEventListener("click", FilterBarDock.onFilterBarClick);
				}
			}
		}
		
		FilterBarDock.filterBarElement = FilterBarDock.filterBar;
		FilterBarDock.filterBarInner = <HTMLElement>FilterBarDock.filterBarElement.firstElementChild;
		// console.log(FilterBarDock.filterBarElement.firstElementChild)
		FilterBarDock.filterBarBottomHeight = FilterBarDock.filterBarInner.offsetHeight + FilterBarDock.filterBarInner.offsetTop;

		const menuBottom = FilterBarDock.mainMenu.offsetTop + FilterBarDock.mainMenu.clientHeight;
		//(FilterBarDock.filterBarElement.firstElementChild as HTMLElement).style.top = `${menuBottom}px`;

		FilterBarDock.dockYPos = FilterBarDock.filterBar.offsetTop - menuBottom;

		window.addEventListener("scroll", FilterBarDock.onScroll);

		FilterBarDock.onScroll();
		
	}

	private static onDocumentLoaded() {
		FilterBarDock.update();
	}

	public static update(){
		FilterBarDock.reInit();
		FilterBarDock.resizeFinished();
	}

	private static onScroll() {
		FilterBarDock.checkDeviderForFilterBar();
		const isDocked = FilterBarDock.filterBarElement.classList.contains("_docked");
		const shouldBeDocked = window.pageYOffset >= FilterBarDock.dockYPos;
		if(isDocked){
			var positionFilter = FilterBarDock.filterBarBottomHeight + window.pageYOffset;
			var positionFooter = FilterBarDock.footer.offsetTop;
			var filterBottomPosition = window.innerHeight + window.pageYOffset - FilterBarDock.footer.offsetTop;
			if(positionFilter >= positionFooter){
				if(FilterBarDock.filterBarInner.style != undefined){
					FilterBarDock.filterBarInner.style.bottom = filterBottomPosition + "px";
					FilterBarDock.filterBarInner.style.top = "auto";
					FilterBarDock.isDockedBottom = true;
				}
			}else{
				if(FilterBarDock.filterBarInner.style != undefined){
					FilterBarDock.filterBarInner.style.bottom = "auto";
					FilterBarDock.filterBarInner.style.top = null;
					FilterBarDock.isDockedBottom = false;
				}
			}
		}

		if(isDocked == shouldBeDocked) {
			return;
		}
		
		if(!FilterBarDock.isDockedBottom){
			FilterBarDock.filterBarElement.classList.toggle("_docked");			
		}
	}

	private static onFilterBarClick(){
		var filterLists = FilterBarDock.filterBarElement.getElementsByClassName("_filterList");
		for(var i =0; i< filterLists.length; i++){
			filterLists.item(i).classList.toggle("_openFilterMenu");
		}

		var openIcon = FilterBarDock.filterBarElement.getElementsByClassName("_filterOpen")[0];
		var closeIcon = FilterBarDock.filterBarElement.getElementsByClassName("_filterClose")[0];	
		var filterCategories = FilterBarDock.filterBarElement.getElementsByClassName("_filterCateogories")[0];
		if(closeIcon != null){
			closeIcon.classList.toggle("hide");
		}

		if(filterCategories != null){
			filterCategories.classList.toggle("hide");
		}
		if(openIcon != null){
			openIcon.classList.toggle("_showMobile");
		}		
	}

	public static removeActiveListItem(list: any){
		for(var i = 0; i < list.length; i++){
			if(list.item(i).classList.contains("_active")){
				list.item(i).classList.remove("_active");
			}
		}
	}

	private static setActiveFilter(selectedFilter:HTMLElement){
		if(selectedFilter.dataset.internaltype === "type"){
			var filterTypeText = document.getElementsByClassName("_filteredType");
			var filterCategory = filterTypeText[0].parentElement;

			let show = (filterCategory != null && filterCategory.classList.contains("_disable"));
			if(filterCategory != null && show){
				filterCategory.classList.remove("_disable");
			}
			var id = selectedFilter.dataset.internalid;
			let isDefault = false;
			if(id != undefined){
				var idI = id;
				if(idI === 'all'){
					isDefault = true;
				}
			}
			if(isDefault){
				if(Menu.isMoblieMenu()){
					(filterTypeText.item(0).parentElement as HTMLElement).style.display = "none";
				}else{
					(filterTypeText.item(0).parentElement as HTMLElement).style.display = "flex";
				}
			}else{
				if(show){
					(filterTypeText.item(0).parentElement as HTMLElement).style.display = "flex";
				}else{
					(filterTypeText.item(0).parentElement as HTMLElement).style.display = "";
				}
			}
			filterTypeText.item(0).innerHTML = selectedFilter.innerHTML;
		}else if(selectedFilter.dataset.internaltype === "season"){
			var filterPlaytimeText = document.getElementsByClassName("_filteredPlaytime");
			var filterCategory = filterPlaytimeText[0].parentElement;

			let show = (filterCategory != null && filterCategory.classList.contains("_disable"));
			if(filterCategory != null && show){
				filterCategory.classList.remove("_disable");
			}
			var id = selectedFilter.dataset.internalid;
			let isDefault = false;
			if(id != undefined){
				var idI = id;
				if(idI === 'all'){
					isDefault = true;
				}
			}
			if(isDefault){
				if(Menu.isMoblieMenu()){
					(filterPlaytimeText.item(0).parentElement as HTMLElement).style.display = "none";
				}else{
					(filterPlaytimeText.item(0).parentElement as HTMLElement).style.display = "flex";
				}
			}else{
				if(show){
					(filterPlaytimeText.item(0).parentElement as HTMLElement).style.display = "flex";
				}else{
					(filterPlaytimeText.item(0).parentElement as HTMLElement).style.display = "";
				}
			}
			filterPlaytimeText.item(0).innerHTML = selectedFilter.innerHTML;
		}	
		FilterBarDock.setActiveFilterDot(selectedFilter);
	}
	

	private static setActiveFilterDot(selectedFilter:HTMLElement){
		if(selectedFilter.parentElement != null){
			if(selectedFilter.classList.contains("icon-close")){
				selectedFilter.parentElement.classList.add("_disable");
				if(selectedFilter.dataset.internaltype === "type"){
					var items = document.getElementsByClassName('_filterListType')[0].getElementsByTagName('li');
					FilterBarDock.removeActiveListItem(items);
					items[0].classList.add("_active");
				}
				if(selectedFilter.dataset.internaltype === "season"){					
					var items = document.getElementsByClassName('_filterListSeason')[0].getElementsByTagName('li');
					FilterBarDock.removeActiveListItem(items);
					items[0].classList.add("_active");
				}
			} else{
				var listItems = selectedFilter.parentElement.children;
				FilterBarDock.removeActiveListItem(listItems);
				selectedFilter.classList.add("_active");
			}
		}
	}

	public static filterChanged(event: MouseEvent){
		var selectedFilter = <HTMLElement>event.target;
		var firstParam = null;
		var secondParam = null;

		FilterBarDock.setActiveFilter(selectedFilter);

		if(selectedFilter.dataset.internaltype === "type"){
			var id = selectedFilter.dataset.internalid;
			if(id != undefined){
				var idI = id;
				if(idI === '-1'){
					firstParam = undefined;
				}else{
					firstParam = idI;
				}
			}
		}else if(selectedFilter.dataset.internaltype === "season"){
			var id = selectedFilter.dataset.internalid;
			if(id != undefined){
				var idI = id;
				if(idI === '-1'){
					secondParam = undefined;
				}else{
					secondParam = idI;
				}
			}
		}
		FilterBarDock.filterChangedCallback(firstParam,secondParam);
	}

	public static setFirstFilter(text:string){
		var selectedFilterContainer = <HTMLElement>document.getElementsByClassName("_filterListSeason").item(0);
		let tempText = undefined;
		if(text !== undefined){
			tempText = text.replace(/ /g,'').toLowerCase();
		}
		if(selectedFilterContainer != null){
			for(var i = 0; i < selectedFilterContainer.children.length; i++){
				if(selectedFilterContainer.children.item(i).innerHTML.replace(/ /g,'').toLowerCase()  === tempText ){
					FilterBarDock.setActiveFilter(<HTMLElement>selectedFilterContainer.children.item(i));
					break;
				}else if(tempText === undefined && selectedFilterContainer.children.item(i).innerHTML === "Alle Veranstaltungen"){
					FilterBarDock.setActiveFilter(<HTMLElement>selectedFilterContainer.children.item(i));
					break;
				}
			}
		}
	}

	public static setFilterBarDate(date:string){
		FilterBarDock.filterBarDate.innerHTML = date;
	}

	public static checkDeviderForFilterBar(){
		if(FilterBarDock.devider != null) {
			let selectedElement: Element | null = null;
			if(FilterBarDock.devider.length === 0){
				FilterBarDock.setFilterBarDate("");
			}else{
				for(let i = 0; i < FilterBarDock.devider.length; ++i) {
					const currentElement = FilterBarDock.devider[i];
	
					var viewportOffset = currentElement.getBoundingClientRect();
					var top = viewportOffset.top;
					if(Utils.isPhone()){
						top += 5;
					}
					if(top > FilterBarDock.filterBarBottomPosition){
						break;
					}
	
					selectedElement = currentElement;
				}
				if(selectedElement != null) {
					FilterBarDock.setFilterBarDate(selectedElement.innerHTML);
	
					const yearString = selectedElement.getAttribute("data-cal-year");
					const monthString = selectedElement.getAttribute("data-cal-month");
	
					if(yearString != null && monthString != null) {
						CalendarWidget.syncMonth(parseInt(yearString), parseInt(monthString));
					}
				}
			}
		}
	}
}